import React, { useEffect, useCallback, useState} from 'react';
import {newScript} from "decentralized/scripting/scripting.js";
import {connect} from 'react-redux';

const SaveScript = ({scriptType, isSaving, setIsSaving, code}) => { 
    let [name, setName] = useState('');
    const onClickDone = useCallback(async () => {
        await newScript(code, scriptType, name);
        setIsSaving(false);
    }, [code, name, setIsSaving, scriptType]);

    if (!isSaving) { return [] };
    return (
        <div className="save-script-flow">
          <input placeholder="Type name for script" type="text" value={name} onChange={(e) => setName(e.target.value)} />
          <div className="save-toolbar">
            <div onClick={() => setIsSaving(false)} className="cancel-btn">Cancel</div>
            <div onClick={onClickDone} className="done-btn">Done</div>
          </div>
          <div className="info">
            To load use <br/>
            <code>
              const fn = load("NAME YOU CHOSE HERE");
            </code>
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveScript);
